import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;

  div {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    width: 100%;

    div + div {
      margin-left: 1rem;
    }

    &:last-child {
      justify-content: flex-end;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
  padding: 1rem 0;
`;
